export const loginMeta = {
  layout: 'single',
  requireAuth: false
}

export const defaultMeta = {
  layout: 'default',
  requireAuth: true,
  roles: ['A', 'E']
}

export const guestMeta = {
  layout: 'default',
  requireAuth: true,
  roles: ['A', 'E', 'C']
}
